const initialState = {
  week: '',
  label: '',
  note: '',
  inCompliance: '',
};

export default initialState;
